import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getCommunityStrategies } from "features/Strategy/service";

export const useActiveStrategies = () => {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["activeStrategies"],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        type: "active",
        page: Number(pageParam),
        size: 10,
        broker_accounts: true,
      };

      const response = await getCommunityStrategies(params);
      return {
        data: response.data,
        currentPage: response.page,
        totalPages: response.total_pages,
        totalCount: response.total_count,
      };
    },
    getNextPageParam: (lastPage) => {
      const currentPage = Number(lastPage.currentPage);
      const totalPages = Number(lastPage.totalPages);
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
  });

  const allStrategiesData = data?.pages?.flatMap((page) => page.data) || [];
  const latestPage = data?.pages?.[data.pages.length - 1];
  const totalPages = latestPage?.totalPages || 0;
  const totalCount = latestPage?.totalCount || 0;
  const currentPage = latestPage?.currentPage || 1;

  return {
    data: allStrategiesData,
    totalCount,
    totalPages,
    isLoading,
    isFetchingNextPage,
    currentPage,
    fetchNextPage,
    hasNextPage,
    refetch,
  };
};
